var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoEspn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 73,
    height: 18,
    viewBox: "0 0 73 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_208_2853)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.291 0H23.779C21.0629 0 19.2663 1.42855 19.0124 3.56785C18.9194 4.35616 18.8291 5.05139 18.8291 5.05139H54.1564C54.1564 5.05139 54.2227 4.52961 54.2735 4.11219C54.54 1.95597 53.6234 0 50.291 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.9225 6.97635C53.9225 6.97635 53.8449 7.68146 53.7363 8.46554C53.5248 10.0069 52.3769 11.1534 50.2432 11.1534H42.7211L41.875 17.9986H35.8872L37.241 6.97635H53.9225Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2313 0L17.6136 5.05139H1.58936L2.20985 0H18.2313Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.35522 6.97635H17.3753L16.862 11.1534H6.8325L6.57866 13.2166H16.6109L16.0215 17.9986H0L1.35522 6.97635Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.997 0H69.0641C71.13 0 73.2693 0.958947 72.8463 4.27437C72.7701 4.86948 72.7476 5.05139 72.7476 5.05139H55.3779L55.997 0Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.138 6.97495L61.1329 6.97777L59.7777 17.9958L53.7856 17.9986L55.138 6.97495Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.5242 6.97495L72.5148 6.97777L71.161 17.9958L65.1689 17.9986L66.5242 6.97495Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.7498 6.97916H18.5882C18.1482 9.856 19.5895 11.1562 21.6287 11.1562H29.736L29.4836 13.2222H17.8225L17.2358 18.0042C17.2358 18.0042 29.9278 18.0042 30.4453 18.0042C30.8684 17.9732 33.8397 17.8928 34.8494 15.4658C35.178 14.6761 35.4671 11.85 35.5545 11.2563C36.0213 7.80836 33.6352 6.98621 31.7554 6.98621",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_208_2853"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72.8997,
    height: 18,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoEspn);
export default __webpack_public_path__ + "static/media/logo-espn.1205371e9d0b44fef024f981aebff7a3.svg";
export { ForwardRef as ReactComponent };